import React from "react";
import AppointmentOverviewList from "./src/appointmentOverviewList";
import SearchControlls from "./src/searchControls";
import LoadingMessage from "./src/loadingMessage";
import Section from "../../components/section/section";

const AppointmentOverviewContainer = (): React.JSX.Element => (
  <Section>
    <SearchControlls />
    <LoadingMessage />
    <AppointmentOverviewList />
  </Section>
);

export default AppointmentOverviewContainer;
